
import * as __star__ from '@clayui/upper-toolbar';

const {
default: __default__,
Input,
Item,
__esModule
} = __star__;

export {
Input,
Item,
__esModule
};
export default __default__;
